module.exports = __webpack_public_path__ + "img/checklist.4065a4e2.svg";